import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchTeams } from 'actions/team';
import Text from 'components/Text';
import DetailsDropdown from 'components/ContentInfo/DropdownInfo';
import { jsx as _jsx } from "react/jsx-runtime";
export var NudgeAudience = function NudgeAudience(_ref) {
  var audience = _ref.audience,
    teamIds = _ref.teamIds;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchTeams = useFetchTeams({
      teamIds: teamIds
    }),
    items = _useFetchTeams.items;
  if (audience === 'all' || !(teamIds !== null && teamIds !== void 0 && teamIds.length)) {
    return /*#__PURE__*/_jsx(Text, {
      children: t('state_everyone')
    });
  }
  return /*#__PURE__*/_jsx(DetailsDropdown, {
    titleKey: t('content_type_team_plural'),
    listItems: items.map(function (team) {
      return /*#__PURE__*/_jsx(Text, {
        bold: true,
        children: team.name
      }, team.id);
    }),
    listLayout: "stack",
    children: t('teams_count', {
      count: items.length
    })
  });
};
export default NudgeAudience;